// extracted by mini-css-extract-plugin
export default {"cardAttachments":"styles__cardAttachments___qLdI9"};